import { EtaLegend } from '@app/components/various/Matrix/EtaLegend';
import { cn } from '@app/utils/cn';
import { useExpander } from '@app/utils/hooks';
import { isEmpty } from '@app/utils/isEmpty';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useMatrixDeliveryWindowContext, useMatrixEtaContext, useMatrixSettingsContext } from './context';
import { MatrixHeader } from './MatrixHeader';

export const ProductMatrixSectionGroup = ({ children }: React.WithChildren) => {
  const { t } = useTranslation(['common']);
  const { isDeliveryWindowExpired } = useMatrixDeliveryWindowContext();
  const { containerRef, hasActiveEta, hoverProps, legendItems, setActiveEta } = useMatrixEtaContext();
  const { isShowingProduct, isReadOnly, isOrderEditable } = useMatrixSettingsContext();
  const [isExpanded, setIsExpanded] = React.useState(!isReadOnly);
  const { sectionProps, triggerProps, sectionClassName } = useExpander({ isExpanded });
  const toggleIsExpanded = () => setIsExpanded(!isExpanded);

  return (
    <div
      ref={containerRef}
      className={cn('rounded-regular border border-neutral-90', {
        etaHighlighted: hasActiveEta,
        'opacity-50': isDeliveryWindowExpired && (!isReadOnly || isShowingProduct) && isOrderEditable,
      })}
      data-testid="productMatrixSection"
      {...hoverProps}
    >
      <MatrixHeader {...triggerProps} onClick={toggleIsExpanded} isExpanded={isExpanded} />
      <section {...sectionProps} className={cn(sectionClassName, 'px-3 lg:px-6')}>
        <div
          className={cn('-mx-1 overflow-hidden px-1', {
            'flex flex-col gap-4 lg:gap-0': !isReadOnly,
          })}
        >
          {children}
          {!isEmpty(legendItems) && (
            <div className="relative z-elevated m-4 flex">
              <EtaLegend label={t('common:arriving_on')} items={legendItems} isHoverable onHover={setActiveEta} />
            </div>
          )}
        </div>
      </section>
    </div>
  );
};
